module.exports = "<form-modal [(form)]=\"form\">\n    <chassis-form [(form)]=\"form\" [modelSubject]=\"model$\"></chassis-form>\n</form-modal>\n"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-core/src/app/quick-addit/modals/quick-addit.modal.html
// module id = ./libs/chassis-core/src/app/quick-addit/modals/quick-addit.modal.html
// module chunks = main